import { FormMapping } from '@app/utils/form-mapping/decorators/form-mapping';
import { Required, StringInput } from '@app/utils/form-mapping/helpers/default-attributes';
import { FormMappingModel } from '@app/utils/form-mapping/models/form-mapping-model';

@FormMapping()
export class LoginNameFormModel extends FormMappingModel {
  @Required
  @StringInput
  loginName: string;
}

@FormMapping()
export class NewPasswordFormModel extends FormMappingModel {
  @Required
  @StringInput
  loginName: string;

  @Required
  @StringInput
  newPassword: string;

  @Required
  @StringInput
  token: string;
}

@FormMapping()
export class TokenFormModel extends FormMappingModel {
  @Required
  @StringInput
  loginName: string;

  @Required
  @StringInput
  token: string;
}
